<template>
	<div>
		<v-simple-table fixed-header class="no-bordes">
			<thead>
				<tr>
					<th>
						Enfermedad
					</th>
					<th>
						Parentesco
					</th>
					<th></th>
				</tr>
			</thead>
			<tbody v-if="!valor.Enfermedades.length">
				<td colspan="5">
					<div class="ma-3">
						No hay enfermedades agregadas
					</div>
				</td>
			</tbody>
			<tbody v-else>
				<template v-for="(enfermedad, i) in valor.Enfermedades">
					<tr :key="i">
						<td>
							{{
								enfermedad.Enfermedad.Descripcion.indexOf(
									"Otras"
								) > -1
									? enfermedad.OtraEnfermedad
									: enfermedad.Enfermedad.Descripcion
							}}
						</td>
						<td>
							<v-select
								return-object
								multiple
								:items="catalogos.Parentescos"
								item-text="Descripcion"
								v-model="enfermedad.Parentesco"
								:label="'Seleccione Parentesco'"
							></v-select>
						</td>
						<td width="50">
							<v-btn icon @click.prevent="quitarEnfermedad(i)">
								<v-icon color="error">close</v-icon>
							</v-btn>
						</td>
					</tr>
				</template>
			</tbody>
		</v-simple-table>
		<v-layout
			row
			justify-end
			style="padding-bottom:10px; padding-right:70px"
		>
			<v-flex xs12 text-right>
				<v-btn color="primary" @click.stop="abrirNuevaEnfermedad">
					añadir enfermedad
				</v-btn>
				<v-btn color="primary" @click.prevent="guardar" class="ml-3">
					<v-icon>arrow_forward_ios</v-icon> SIGUIENTE
				</v-btn>
			</v-flex>
		</v-layout>
		<v-dialog v-model="enfermedad_nueva" width="500px" persistent>
			<v-card ma-5>
				<v-card-title class="text-h5 primary--text">
					Añadir Enfermedad
					<v-spacer></v-spacer>
					<v-btn icon @click.prevent="cerrarNuevaEnfermedad">
						<v-icon>close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-form
						ref="formNuevaEnfermedad"
						@submit.prevent="crearNueva"
					>
						<v-layout column>
							<v-autocomplete
								required
								:rules="[
									!!nueva.Enfermedad || 'Campo Requerido'
								]"
								v-model="nueva.Enfermedad"
								:items="enfermedadesDisponibles"
								item-text="Descripcion"
								return-object
								label="Enfermedad"
							></v-autocomplete>
							<v-text-field
								required
								:rules="[
									!!nueva.OtraEnfermedad || 'Campo Requerido'
								]"
								v-if="
									nueva.Enfermedad &&
										nueva.Enfermedad.Descripcion.indexOf(
											'Otras'
										) > -1
								"
								v-model="nueva.OtraEnfermedad"
								label="Especifique Enfermedad"
							></v-text-field>
							<v-select
								required
								:rules="[
									!!nueva.Parentesco.length ||
										'Campo Requerido'
								]"
								multiple
								return-object
								:items="catalogos.Parentescos"
								item-text="Descripcion"
								label="Seleccione Parentesco"
								v-model="nueva.Parentesco"
							></v-select>
							<v-btn type="submit" color="primary">Guardar</v-btn>
						</v-layout>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import ServicioCatalogos from "../../../services/catalogos";
import ServicioHistorialClinico from "../../../services/historialClinico";
import { Catalogos } from "../../../services/catalogos";
export default {
	name: "antecedentesHeredofamiliares",
	data() {
		return {
			catalogos: {
				Enfermedades: [],
				Parentescos: []
			},
			valor: {
				Enfermedades: []
			},
			enfermedad_nueva: false,
			nueva: {
				Nombre: "",
				Parentesco: []
			}
		};
	},
	methods: {
		cerrarNuevaEnfermedad() {
			this.enfermedad_nueva = false;
		},
		quitarEnfermedad(index) {
			this.valor.Enfermedades.splice(index, 1);
		},
		abrirNuevaEnfermedad() {
			this.nueva = {
				Nombre: "",
				Parentesco: []
			};
			if (this.$refs.formNuevaEnfermedad) {
				this.$refs.formNuevaEnfermedad.reset();
			}
			this.enfermedad_nueva = true;
		},
		crearNueva() {
			if (this.$refs.formNuevaEnfermedad.validate()) {
				this.valor.Enfermedades.push({ ...this.nueva });
				this.enfermedad_nueva = false;
			}
		},
		siguiente() {
			this.$emit("siguiente");
		},
		async obtenerCatalogos() {
			let res = await ServicioCatalogos.getCatalogo(
				Catalogos.HistorialClinico_Enfermedades
			);
			this.catalogos.Enfermedades = res.data.data.Table0;
			res = await ServicioCatalogos.getCatalogo(
				Catalogos.HistorialClinico_Parentesco
			);
			this.catalogos.Parentescos = res.data.data.Table0;
		},
		async guardar() {
			const datos = {
				HistoriaClinicaID: this.historiaCliniciaId,
				json: JSON.stringify(this.valor)
			};
			const res = await ServicioHistorialClinico.guardarAntecedentesHeredofamiliares(
				datos
			);
			if (res.data.result === 1) {
				this.siguiente();
			} else {
				this.$root.mensajeError = res.data.message;
			}
		}
	},
	computed: {
		enfermedadesDisponibles() {
			return this.catalogos.Enfermedades.filter(
				e =>
					e.Descripcion.indexOf("Otras") > -1 ||
					!this.valor.Enfermedades.some(
						e2 => e2.Enfermedad.CDID === e.CDID
					)
			);
		},
		historiaCliniciaId() {
			return this.$route.params.historiaClinicaId;
		}
	},
	async mounted() {
		await this.obtenerCatalogos();
	},
	props: ["datos"],
	watch: {
		datos() {
			if (this.datos) {
				this.valor = JSON.parse(this.datos);
			}
		}
	}
};
</script>

<style></style>
